
<div>
  <text-input
    id="email"
    v-model="form.email"
    type="email"
    label="Email"
    required
    maxlength="64"
  />

  <password-input
    id="password"
    v-model="form.password"
    label="Password"
    required
  />
</div>
